import React from 'react';
import { Icon } from 'rhinostyle';
import { findDurationFromMilliseconds } from '../../helpers/DateHelpers';
import RhinoVoipVoicemailPlayer from '../RhinoVoipVoicemailPlayer';

const VoipCallEvent = ({ event }) => {
  const {
    formattedTimestamp,
    callerNumber,
    destinationNumber,
    callerContactName,
    destinationContactName,
    direction,
    status,
    duration,
    voicemailMessageId,
    voicemailDuration,
  } = event;

  const isInbound = direction === 'inbound';
  const isOutbound = direction === 'outbound';

  const otherParty = isInbound
    ? (callerContactName || callerNumber || 'Unknown')
    : (destinationContactName || destinationNumber || 'Unknown');

  const directionLabel = isInbound ? 'Incoming' : isOutbound ? 'Outgoing' : 'Call'; // eslint-disable-line no-nested-ternary

  let statusLabel = status
    ? status.charAt(0).toUpperCase() + status.slice(1)
    : '';
  if (statusLabel && voicemailDuration) {
    statusLabel += ` (${voicemailDuration}s)`;
  }

  return (
    <div className="convo__event convo__event--voip-call" data-cypress="voipCallEvent">
      <div className="convo__event__title">
        <Icon bump="up" icon="phone" className="convo__event__icon" />
        <span className="convo__event__voip-direction">{directionLabel}</span>
        {' call '}
        {isInbound ? 'from ' : 'to '}
        <strong>{otherParty}</strong>
        {statusLabel && (
          <span className="convo__event__voip-status"> — {statusLabel}</span>
        )}
      </div>
      <div className="convo__event__subtext">
        {formattedTimestamp}
        {duration > 0 && ` (${findDurationFromMilliseconds(duration)})`}
      </div>
      {voicemailMessageId && (
        <div className="convo__event__voicemail">
          <RhinoVoipVoicemailPlayer voicemailMessageId={voicemailMessageId} />
        </div>
      )}
    </div>
  );
};

export default VoipCallEvent;
